const cpfCnpjMixin = {
    methods: {
        ajustaCpf(event) {
            let cpf = event.target.value;
            cpf = cpf.replace(/\D/g, "");
            cpf = cpf.padStart(11, '0');
            cpf = cpf.replace(/\D/g, '')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1-$2')
                .replace(/(-\d{2})\d+?$/, '$1')
            event.target.value = cpf;
        },
        ajustaCnpj(event) {
            let cnpj = event.target.value;
            cnpj = cnpj.replace(/\D/g, "");
            cnpj = cnpj.padStart(14, '0');
            cnpj = cnpj.replace(/\D/g, '')
                .replace(/(\d{2})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1/$2')
                .replace(/(\d{4})(\d)/, '$1-$2')
                .replace(/(-\d{2})\d+?$/, '$1');
            event.target.value = cnpj;
        },
        ajustaCpfCnpj(event) {
            let cpfCnpj = event.target.value;
            cpfCnpj = cpfCnpj.replace(/\D/g, "");

            if (cpfCnpj.length > 11)
                this.ajustaCnpj(event);
            else
                this.ajustaCpf(event);
        }
    }
};

export default cpfCnpjMixin;